<template>
    <div class="auditOpinionPop">
        <header>请填写审批意见</header>
        <div class="option-con">
            <el-input
                type="textarea"
                placeholder="请输入意见"
                class="option"
                v-model="opinionText"
            ></el-input>
        </div>
        <div class="text-center">
            <el-button type="primary" @click="onSubmit">
                审批通过
            </el-button>
            <el-button @click="closeFn">
                取消
            </el-button>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        extr: {
            type: [Object],
        },
    },
    data() {
        return {
            opinionText: '',
        };
    },
    watch: {},
    computed: {},
    methods: {
        onSubmit() {
            if (this.opinionText) {
                this.$axios.get('/interfaceApi/Procurement/Catalogs/goods/approval/' + this.extr.rowData.id + '/'
            + 1 + '?opinion=' + this.opinionText)
                    .then(res => {
                        if (res) {
                            this.$message.success('审核成功');
                            window.hideToast();
                            window.updateTable();
                        }
                    }).catch(error => {
                        this.$message.error(error.ErrorCode.Message);
                    });
            } else {
                this.$message.warning('请输入审核意见');
            }

        },
        closeFn() {
            window.hideToast();
        },
    },
    created() {},
    mounted() {},
};
</script>
<style lang="stylus">
.auditOpinionPop
    header
        height 60px
        background #4f67ad
        line-height 60px
        color #fff
        text-align center
        font-size 18px
    .types
        padding 50px 20px
    .text-center
        text-align center
        position absolute
        bottom 30px
        width 100%
    .option-con
        padding 30px 20px 20px 20px
        textarea
            height 150px
</style>